import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import QuizList from './QuizList';
import QuizCreation from './QuizCreation';
import QuizTake from './QuizTake';
import QuizReports from './QuizReports';
import QuizUserResultContainer from './QuizUserResultContainer';
import QuizStartConfirm from './QuizStartConfirm';

export default function Quiz() {
    return (
        <Switch>
            <Route path="/quizzes/new" component={QuizCreation}/>
            <Route exact path="/quizzes/:quizUserId(\w+)/answers" component={QuizUserResultContainer}/>
            <Route exact path="/quizzes/:quizId(\w+)/:actionType(edit)" component={QuizCreation}/>
            <Route exact path="/quizzes/:quizId(\w+)/:actionType(preview)" component={QuizTake}/>
            <Route exact path="/quizzes/:quizId(\w+)/:actionType(take)" component={QuizTake}/>
            
            <Route exact path="/quizzes/:quizId(\w+)/reports" component={QuizReports}/>
            <Route path="/quizzes" component={QuizList}/>
            <Redirect to="/quizzes"/>
        </Switch>
    );
}
